/**
 * @expFlag promo-in-webview-public
 * @ticket CLOUDWEB-20374
 * @file
 */
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

type PromoInWebviewPublicType = {
    type: 'a' | 'b' | 'c';
    href: string;
};

export const PROMO_ID = 'promo-in-webview-public';

export const abPromoInWebviewPublic: false | PromoInWebviewPublicType = IS_WEBVIEW && IS_MOBILE_BROWSER && getFeature(PROMO_ID);
